import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class directoryView_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return `

            <div data-bind="visible: $parent.idTemplate() == 7">
                <div class="w-form-body directory-content directory-content-view ">
                    <strong class="form-sub-title directory" >Directory</strong>
                    <div class="form-body">
                        <script id="directoryViewElement" type="text/html" >
                            <div data-bind="foreach : directoryItems">
                                <li class="list-item"> 
                                <div class="inner-wrap">
                                    <div>
                                        <strong class="item-title" data-bind="text: sectionTitle"></strong> 
                                        <div class="item-description" data-bind="html: description"></div>
                                        <span data-bind="if: item">
                                            <span data-bind="if: item.alternativeArticleTitle">
                                              <a class="item-link" data-bind="text: item.alternativeArticleTitle, attr: { href: 'https://'+$parent.brand().domain+'/'+permalink }" target="_blank" ></a>
                                            </span>
                                            <span data-bind="ifnot: item.alternativeArticleTitle">
                                              <a class="item-link" data-bind="text: item.title, attr: { href: 'https://'+$parent.brand().domain+'/'+item.permalink }" target="_blank" ></a>
                                            </span>
                                        </span>
                                    </div> 
                                </div>
                                <!-- ko if: directoryItems.length > 0 -->
                                 <ul class="list" data-bind="template: {name:'directoryViewElement', data: { directoryItems : directoryItems, brand: $parent.brand }}"></ul>
                                <!-- /ko -->
                                </li>
                            </div>
                        </script>
                       
                        <div class="form-group">
                            <ul class="list" data-bind="template: {name:'directoryViewElement', data: { directoryItems : directoryItems, brand: brand }}"></ul>
                        </div>
                     </div>
                      
                </div>
          
           </div>
        `;
    }
    public buildViewModel() {

        return {
            brand:ko.observable(""),
            directoryItems: ko.observableArray([]),
            articleTitle: ko.observable("article"),
            articleTitles: ko.observableArray([])
        };
    }

    public setBrand(brand){

        this.getTemplateViewModel().brand(brand)
    }

    public setDirectoryItems(directoryItems) {

        this.getTemplateViewModel().directoryItems(directoryItems);
    }

    protected getTemplateName(): string {

        return "directoryView_template";
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/directoryView_template.ts